import React from "react";
import { useSelector } from "react-redux";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";

import classnames from "classnames";
import StepOptions from "./StepOptions";
import StepAatbOptions from "./StepAatbOptions";
import useMemberShip from "store/customHooks/useMemberShip";

const Main = (props) => {
    const {
        myInitInfo,
        reset,
        setMyInitInfo,
        saveAatbInfo,
        setSaveAatbInfo,
        stepTab,
        stepToggle,
        gradeCodes,
        primeLevelCodes,
        primeWeekCodes,
    } = props;

    const pedcCd = useSelector((state) => state.loginReducer.pedcCd);
    const isPrimePedcCd = pedcCd === "PEDC-00015" || pedcCd === "PEDC-00016";

    const { ckALTB } = useMemberShip();
    const ALTB = ckALTB();

    return (
        <>
            <Nav tabs className="scheduleTab">
                <NavItem className={classnames({ active: stepTab === "1" })}>
                    <NavLink className={classnames({ active: stepTab === "1" })}>
                        <span>1</span>학년,학교{isPrimePedcCd && ",레벨,요일"} 선택
                    </NavLink>
                </NavItem>
                <NavItem className={classnames({ active: stepTab === "2" })}>
                    <NavLink className={classnames({ active: stepTab === "2" })}>
                        <span>2</span>우리학교 교과서 설정
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={stepTab} className="schedule-setting-wrapper">
                <TabPane tabId="1" className="schedule-setting-content">
                    {/* 학년, 학교선택 */}
                    <StepOptions
                        myInitInfo={myInitInfo}
                        setMyInitInfo={setMyInitInfo}
                        stepToggle={stepToggle}
                        setSaveAatbInfo={setSaveAatbInfo}
                        gradeCodes={gradeCodes}
                        primeLevelCodes={primeLevelCodes}
                        primeWeekCodes={primeWeekCodes}
                        isPrimePedcCd={isPrimePedcCd}
                        ALTB={ALTB}
                    />
                </TabPane>
                <TabPane tabId="2" className="schedule-setting-content">
                    {/* 우리학교 교과서 설정 */}
                    <StepAatbOptions
                        reset={reset}
                        myInitInfo={myInitInfo}
                        saveAatbInfo={saveAatbInfo}
                        setSaveAatbInfo={setSaveAatbInfo}
                        stepToggle={stepToggle}
                        stepTab={stepTab}
                        isPrimePedcCd={isPrimePedcCd}
                    />
                </TabPane>
            </TabContent>
        </>
    );
};

export default Main;
